'use strict';

require("@babel/polyfill/noConflict");
const $ = require('jquery');
const webChatIFrameInit = require('../modules/webChatIFrameInit');
const commonValidations = require('../modules/webChatCommonValidations');
const eventResponseProcessor = require('../modules/eventResponseProcessor');
const applyWindowState = require('../modules/applyWindowState');
const webChatConfig = require('../modules/webChatConfig');
const webChatCommonApiUtils = require('../modules/webChatCommonApiUtils');
const i18n = require('../modules/utils/webChat-i18n');
const StompJs = require('@stomp/stompjs');
const {error} = require("loglevel");
const Versions = require('@stomp/stompjs').Versions;

// Live Chat specific variables
let iChannelName;

// Variable to indicate what state the Web Chat Client is initially in.
let webChatState = 0;

// Temporary array to store interval ids.
let eventIntervalIdsTemp = [];

const COVERCHECK_PAGEID = 'selfservice';
const COVERCHECK_CHANNEL = 'COVERCHECKWEB';
const MYVHI_CHANNEL = 'MYVHI';
// Variables used for Customer Typing message
const RETURNKEYCHARCODE = 13;
const SPACEBARCHARCODE = 32;
const MIN_TYPING_COUNTER = 2; // min number of keystrokes before a spacebar per typing indicator message
const MAX_TYPING_COUNTER = 4; // max number of keystrokes per typing indicator message
const CLEAR_REGEXP = /^(\s)+$/;
const WEBCHAT_PREFIX = 'webchat.';
let typingCounter = 0;

// Variable to hold URL that user is wishing to navigate away too when leaving the Portal Application.
let urlNavigatingToo = null;

let stompClient = null;
let subscription = null;

/**
 * StompJs v5+ versions have critical dependency on TextEncoder/TextDecoder to work in old browsers (e.g. IE 11)
 * https://stomp-js.github.io/guide/stompjs/rx-stomp/ng2-stompjs/pollyfils-for-stompjs-v5.html
 */
if (typeof TextEncoder !== 'function') {
  const TextEncodingPolyfill = require('text-encoding');
  window.TextEncoder = TextEncodingPolyfill.TextEncoder;
  window.TextDecoder = TextEncodingPolyfill.TextDecoder;
}

const close_button = () => {
  webChatState = webChatConfig.STATE_CLOSED_BUBBLE_ONLY();
  $('#startChatCTA').prop('disabled', false);
  applyWindowState.applyWindowState(webChatState);
  // Clear out variable in case user had clicked on link (MyVhi) to navigate away
  // from Portal and have now changed their mind.
  urlNavigatingToo = null;
};

/**
 * This will determine the state to open the chat window in if there is an existing active chat or not.
 */
const determineOpenChatState = () => {
  if (
    webChatConfig.resetQueueMessageFlag() !== null &&
    webChatConfig.resetQueueMessageFlag()
  ) {
    // If user is still in a queue, then show queue message.
    webChatState = webChatConfig.STATE_OPEN_QUEUE();
  } else if (webChatConfig.is2FAActive()) {
    // If user is in an PIN 2FA
    webChatState = webChatConfig.STATE_OPEN_PIN_REQUEST();
  } else if (webChatConfig.chatActive()) {
    // If user is in an active web chat, show active status.
    webChatState = webChatConfig.STATE_OPEN_ACTIVE_WEB_CHAT();
  } else {
    // Otherwise show user the enter name state.
    webChatState = webChatConfig.STATE_OPEN_ENTER_NAME();
  }
};

/**
 * Attempt to send browser to link (MyVhi) that user clicked on while in an active chat
 * which forced them to end the chat first.
 */
const navigateToUrl = () => {
  if (urlNavigatingToo !== null && urlNavigatingToo.length > 0) {	
    console.log('navigateToUrl invoked');
    parent.postMessage({operation: 'navigateToUrl', url: urlNavigatingToo}, '*');
    urlNavigatingToo = null;
  }
};

/**
 * Collapse the VHI Main Menu (will only exist on mobile devices) if it's open.
 */
 const navMenuCollapse = () => {
  console.log('Nav menu collapse invoked');
  parent.postMessage({operation: 'navMenuCollapse'}, '*');
};


/**
 * Validation rules for click of Submit Email address for requesting a Transcript.
 */
const submitEmailValidationRules = {
  transcriptEmailAddress: {
    webChatEmailAddress: {
      errorKey: 'web.chat.email.Invalid',
    },
  },
};

/**
 * This function will be called if user clicks submit button after entering their email address to
 * receive a transcript of chat.
 */
const applySubmitTranscriptEmailValidations = () => {
  return $('#webChatEmailTranscriptForm').validate({
    onkeyup: false,
    onclick: false,
    onfocusout: false,
    rules: submitEmailValidationRules,
    errorPlacement: function (error, element) {
      error.insertAfter(element);
    },
    submitHandler: submitTranscriptCustomEmailAddress,
  });
};

const submitTranscriptEmailAddress = (emailAddress) => {
  // Send email address as a message to Live Chat Server to send Transcript to.
  stompClient.publish({
    destination: '/app/secured/room',
    body: JSON.stringify({content: 'EMAIL TRANSCRIPT REQUESTED TO BE SENT TO : ' + emailAddress})
  });

  setTimeout(() => {
    webSocketDisconnectGracefully();

    webChatState = webChatConfig.STATE_OPEN_ENDED_TRANSCRIPT_SENT();
    applyWindowState.applyWindowState(webChatState);
  }, 2000);
};

const submitTranscriptCustomEmailAddress = () => {
  console.log('*** Submitting EMAIL Address ***');
  // Get email address from Web Chat Client.
  let transcriptEmailAddress = $('#transcriptEmailAddress');
  const emailAddress = transcriptEmailAddress.val();

  // Clear out the Email Address input box
  transcriptEmailAddress.val('');
  submitTranscriptEmailAddress(emailAddress);
};

/**
 * Transcript Email Setup
 */
const applyTranscriptEmailSetup = () => {
  $('#customEmailAddress').click((e) => {
    e.preventDefault();
    applyWindowState.hideElement('#defaultEmailAddressContent');
    applyWindowState.showElement('#customEmailAddressContent');
  });

  $('#submitDefaultEmailChatCTA').click((e) => {
    e.preventDefault();
    const emailAddress = webChatConfig.userEmail();
    submitTranscriptEmailAddress(emailAddress);
  });
};

/**
 * Validation rules for click of Send Message button.
 */
const sendMessageValidationRules = {
  message: {
    webChatRequired: {
      errorKey: 'web.chat.message.Invalid',
    },
  },
};

/**
 * This function will be called to validate message when user enters a message.
 */
const applySendMessageValidations = () => {
  return $('#webChatForm').validate({
    onkeyup: false,
    rules: sendMessageValidationRules,
    errorPlacement: function (error, element) {
      $('#message').attr('placeholder', error.text());
    },
    submitHandler: submitMessageForm,
  });
};

/**
 * This will register key presses in the message input box to inform agent that user is typing.
 */
const registerKeyHandlers = () => {
  document.onkeydown = suppressBackspace;
  document.onkeypress = suppressBackspace;
  document.getElementById('message').onkeyup = handleKeyPressed;
  // Only execute captureEvents function if browser is not IE.
  if (isGecko()) {
    document.addEventListener(Event.KEYUP, handleKeyPressed);
    document.getElementById("message").onkeyup = handleKeyPressed;
  }
  else {
    document.getElementById("message").onkeyup = handleKeyPressed;
  }
};

/**
 * Send user typing message to Agent.
 */
const handleKeyPressed = (e) => {
  const keyCode = getEventKeyCode(e);
  if (keyCode !== RETURNKEYCHARCODE) {
    sendUserTyping(keyCode);
    return;
  }
  const strMessage = getUserSendMessageValue();
  // If message input box is blank, then clear it out and reset the typing counter.
  if (isCompletelyBlank(strMessage)) {
    $('#message').val('');
    resetTypingCounter();
  }
};

/**
 * Check if value is blank.
 */
const isCompletelyBlank = (string) => {
  if (null === string || string.length === 0) {
    return true;
  }
  return CLEAR_REGEXP.test(string);
};

/**
 * Check is browser is Gecko based.
 */
const isGecko = () => {
  return navigator.userAgent.indexOf('Gecko') !== -1;
};

/**
 * Ignore Backspace.
 */
const suppressBackspace = (evt) => {
  evt = evt || window.event;
  const target = evt.target || evt.srcElement;
  if (evt.keyCode === 8 && !/input|text/i.test(target.nodeName)) {
    return false;
  }
};

/**
 * Get event associated with key press
 */
const getEventKeyCode = (e) => {
  if (isGecko()) {
    return e.which;
  }
  return window.event.keyCode;
};

/**
 * Send user typing message to agent if user has entered a number of characters or space bar.
 */
const sendUserTyping = (keyCode) => {
  typingCounter++;
  if (
    typingCounter > MIN_TYPING_COUNTER &&
    (typingCounter > MAX_TYPING_COUNTER || keyCode === SPACEBARCHARCODE)
  ) {
    resetTypingCounter();
    customerTyping();
  }
};

const customerTyping = () => {
  stompClient.publish({
    destination: '/app/secured/room',
    body: JSON.stringify({content: null, type: 'USER_TYPING'})
  });
};

/**
 * Determine based on configuration in web-chat-config.properties file if the Web Chat Client should show
 * on the page. If it should then make call to live Web Chat server to determine if Web Chat is available.
 */
const checkWebChatAvailability = (chatPresentedToUser) => {
  console.log('About to check if web chat client should be shown on page');

  // If Web Chat has already been presented to user, then  the channel name for whatever page the Web Chat Client
  // was first offered to the user will be used (this will have been set into LiveChat.Config.availabilityCriteria.launchCode
  // in function checkForActiveWebChatInSession()) . Otherwise get Channel Name from Configuration for page.
  if ( !chatPresentedToUser ) {
    iChannelName = webChatConfig.channelName();
    if (webChatConfig.pageId() === COVERCHECK_PAGEID) {
      iChannelName = COVERCHECK_CHANNEL;
    }
  }

  // Get time in seconds for When to Show Web Chat on page from Configuration for page.
  let whenToShowOnPage = webChatConfig.timeToDisplay();

  // If time period indicates that web chat should not be shown to user on current page, but chat has already been
  // presented to user, then show web chat to user as soon as current page loads.
  if ( (whenToShowOnPage === null || isNaN(whenToShowOnPage)) && chatPresentedToUser ) {
    whenToShowOnPage = '0';
  }

  if (whenToShowOnPage !== null) {
    whenToShowOnPage = whenToShowOnPage.trim();
    if (whenToShowOnPage !== '' && !isNaN(whenToShowOnPage)) {
      webChatClientSetup(whenToShowOnPage, chatPresentedToUser);
    }
  }
};


/**
 * If an Channel Name exists, then populate it in the config so it can be used later.
 */

/**
 * Determine based on configuration in web-chat-config.properties file if the Web Chat Client should show on
 * page after a time period. Then make an Ajax call to Live Chat Server to see if Web Chat if available.
 */
const webChatClientSetup = (whenToShowOnPage, chatPresentedToUser) => {
  checkAvailability(whenToShowOnPage, chatPresentedToUser);
};

/**
 * Function to make call to Live Chat Server to check if it is available and show Web Chat Client if it is.
 */
const checkAvailability = (whenToShowOnPage, chatPresentedToUser) => {
  // If Chat has already been presented to a customer, then show it to them again reagardless of availability of system,
  // otherwise check availability of Web Chat Server.
  if (chatPresentedToUser) {
    determineWhenToShowWebChatClient(whenToShowOnPage, false);
  } else {
    // Check availability to ensure Web Chat is available.
	  webChatCommonApiUtils.getCurrentWebChatAvailability(iChannelName, webChatConfig.queues())
    .then( data => {
      console.log('Availability response: ', data);
      processAvailability(data, whenToShowOnPage);
    })
    .catch((error) => {
      console.log(error);
    });
  }
};

const processAvailability = (data, whenToShowOnPage) => {
  if (data) {
    console.log('Availability: ', data.isChatAvailable);
    console.log('Reason: ', data.availabilityStatus);
  }
  if (data && data.isChatAvailable && data.isChatAvailable === 'true') {
    determineWhenToShowWebChatClient(whenToShowOnPage, true);
  } else {
    // If flag for an active Web Chat exists in Session then display agents offline message.
    // This is really fail safe code as this function will only be executed if not in an active Web Chat.
    if (webChatConfig.chatActive()) {
      applyWindowState.applyWindowState(
        webChatConfig.STATE_OPEN_AGENTS_OFFLINE()
      );
    }
  }
};

/**
 * Function will check how long to wait before showing Web Chat client on screen. This time
 * period is stored in web-chat-config.properties file. Once shown, a flag is stored in session
 * to indicate that web chat has been presented to the user. This is needed in case the user
 * switches pages but has not started a web chat.
 */
const determineWhenToShowWebChatClient = (whenToShowOnPage, storeFlagInSession) => {
  // Check if Web Chat Client Should be shown immediately or after a specified period of time. If no value exists then
  // client should not be shown. If bubble after closing Webchat already appear on the page then client should not be shown.
  console.log('About to check when to show web chat client on page');
  if (whenToShowOnPage !== null) {
    whenToShowOnPage = whenToShowOnPage.trim();
    if (whenToShowOnPage !== '' && !isNaN(whenToShowOnPage) && $('#bubbleOnly').is(":hidden")) {
      if (whenToShowOnPage === 0) {
        console.log('Showing web chat client on page - ' + whenToShowOnPage);
        if (!$('#enterName, #startChatCTAAuthText').is(":visible")) {
          showWebChatClientClosed();
        }
      } else {
        console.log('Showing web chat client on page - ' + whenToShowOnPage);
        if (!$('#enterName, #startChatCTAAuthText').is(":visible")) {
          setTimeout(showWebChatClientClosed, whenToShowOnPage * 1000);
        }
      }
      // Store chatPresentedToUser in session in case user doesn't start a chat.
      if (storeFlagInSession) {
        let chatPresentedToUser = false;
        const isAuthenticated = webChatConfig.isAuthenticated();
        if (isAuthenticated) {
          chatPresentedToUser = true;
          if (webChatConfig.pageId() === COVERCHECK_PAGEID) {
            iChannelName = COVERCHECK_CHANNEL;
          } else {
            iChannelName = MYVHI_CHANNEL;
          }
        }
        const userName = webChatConfig.userName();
        const webChatContent = {
          chatPresentedToUser: chatPresentedToUser,
          channelNameToUse: iChannelName,
          isAuthenticated: isAuthenticated,
          userName: userName
        };
        webChatCommonApiUtils.storePortalSession(webChatContent);
      }
    }
  }
};

/**
 * This function will show the Web Chat Client. It will also make an Ajax call to App Server session to see if any active Web Chat messages exist and display
 * it in Web Chat Client.
 */
const showWebChatClientClosed = () => {
  // Show Web Chat Client as closed.
  webChatState = webChatConfig.STATE_CLOSED();
  console.log('WEBCHATSTATE IS : ' + webChatState);
  applyWindowState.applyWindowState(webChatState);
};

/**
 * Make call to APP Server to check if an existing Web Chat has been saved to user session.
 */
const checkForActiveWebChatInSession = () => {
  console.log(Date(), ': Retrieving webchat information.');
  let chatAlreadyPresentedToUser = false;

  // Make sure we run updateIsAuthenticated every time to ensure we correctly set webChatConfig.setIsAuthenticated which drive Channel name etc
  updateIsAuthenticated()
  .then(
  webChatCommonApiUtils.getCurrentWebChatInSession()
    .then( data => {
      // handle success
      console.log('Is there a current active chat: ', data.chatActive);
      if (webChatConfig.isAuthenticated() && data.userName !== null && data.userName.length > 0) {
        webChatConfig.setUserName(data.userName);
      }

      if (data.chatActive) {
        chatAlreadyPresentedToUser = true;
        updateWebChatConfig(data);
        webChatCommonApiUtils.isAuthenticated().then( data => {
          webChatConfig.setIsAuthenticated(data);
        }).catch((error) => {
          console.log('Error received calling WAM services check on ONTCred Cookie: ' + error);
          console.log('Chat will not be authenticated.');
        });

        if (data.webChatWindowMinimised) {
          // Show Web Chat Client as minimised.
          webChatState = webChatConfig.STATE_OPEN_MINIMISED();
          webChatConfig.setUnreadMessagesCount(data.unreadMessagesCount);
        } else {
          // Show Web Chat Client as open and active web chat in progress.
          webChatState = webChatConfig.STATE_OPEN_ACTIVE_WEB_CHAT();
        }
        applyWindowState.applyWindowState(webChatState);

        writeMessagesInClientWindow(data);
        webChatCommonApiUtils.getWebSocketServiceUrl().then( wsHost => {

          const wsService = '/websocket';
              const wsContext = '/secured/room/websocket';
              const wsChatId = 'chatId=';
              const wsUrl = wsHost + wsService + wsContext + '?' + wsChatId + data.webChatId;
              console.log('WebSocket re-connection URL: ', wsUrl);
              establishWebSocketConnection(wsUrl);
        });
		
        // If no agent name exists then this means customer is still in a queue so show queue message and
        // check for queue status.
        if (data.agentName === null || data.agentName.length < 1) {
          loadQueueMessage();
        }
      }

      if (data.chatPresentedToUser) {
        chatAlreadyPresentedToUser = data.chatPresentedToUser && data.chatActive;
	      webChatConfig.setChannelName(data.channelNameToUse);
      }

    })
    .catch((error) => {
      // handle error
      console.log('Error received calling /retrieveWebChatHistory', error);
    })
    .then(() => {
      // Always executed
      console.log('Completed call to Retrieve Web Chat History');
      // If not in an existing web chat, then check if Web Chat client should be shown. If already in
      // an active chat, then client will have been shown in response to this call.
      if (!webChatConfig.chatActive()) {
        checkWebChatAvailability(chatAlreadyPresentedToUser);
      }
    })
  );
};


const updateIsAuthenticated = () => {

  let authFunction = $.Deferred();
  // Save isAuthenticated.

  webChatCommonApiUtils.isAuthenticated().then(data => {
    if (data === true) {
      webChatConfig.setIsAuthenticated(true);
    } else {
      // We are going to begin a new chat now since we found an instance where we just deleted a cookie,
      // need to reset page Channel, meaning the last chat was authed
      authChatCookieDeletedStartNewUnauthChat();
    }
  });

  authFunction.resolve( "done" );
  return authFunction.promise();
};


/**
 * Update field values in webConfig.js based on data retrieved from active Web Chat that
 * was previously stored in server session.
 */
const updateWebChatConfig = (respData) => {
  // Update flag to indicate user is now in an active Web Chat.
  webChatConfig.setChatActive(true);
  parent.postMessage({operation: 'chatStatus', status: 'active'}, '*');
  // Update counter for number of agents connected to chat.
  webChatConfig.setNbrConnectedAgents(respData.nbrConnectedAgents);

  // Save user name from session into current page as this will be needed if exisitng active chat.
  if (respData.userName !== null && respData.userName.length > 0) {
    webChatConfig.setUserName(respData.userName);
  }

  // Save agent name from session into current page as this will be needed if exisitng active chat.
  if (respData.agentName !== null && respData.agentName.length > 0) {
    webChatConfig.setAgentName(respData.agentName);
  }
};

/**
 * Call Javascript function to store messages in Web Chat client window.
 */
const writeMessagesInClientWindow = (respData) => {
  if (respData.messages !== null && respData.messages.length > 0) {
    for (const element of respData.messages) {
      applyWindowState.writeTextMessageInDisplay(element.message);
    }
  }
};

/*
 * refactored code starts here.  Code above will move down as its pulled in.
 */

const setupConsoleLogging = () => {
  let DEBUG_MODE = false;
  let consoleLoggingEnabled = webChatConfig.isLoggingOn();
  if (consoleLoggingEnabled !== undefined) {
    consoleLoggingEnabled = consoleLoggingEnabled.trim();
    // If Flag in web-chat-config.properties is set to TRUE, then turn on logging.
    if (consoleLoggingEnabled !== null && consoleLoggingEnabled === 'true') {
      DEBUG_MODE = true;
    }

    // If console doesn't exist (IE perhaps), then disable logging.
    if (typeof console === "undefined") {
      console = {};
    }

    // If configuration flag is not true, then disable logging.
    if (!DEBUG_MODE || typeof console.log === "undefined") {
      // FYI: Firebug might get cranky...
      console.log =
        console.error =
        console.info =
        console.debug =
        console.warn =
        console.trace =
        console.dir =
        console.dirxml =
        console.group =
        console.groupEnd =
        console.time =
        console.timeEnd =
        console.assert =
        console.profile =
          function () {};
    }
    console.log('*** Logging Turned On for Web Chat. ***');
  }
};

const setupConfig = () => {
  console.log('webChat.js setupConfig()');
  // Added this for IE to get over Cross Site Scripting issue
  $.support.cors = true;

};

const getStompReconnectDelay = () => {
  return i18n.translate(WEBCHAT_PREFIX + "stomp-config" + '.reconnect-delay');
};

const getStompHeartbeatIncoming = () => {
  return i18n.translate(WEBCHAT_PREFIX + "stomp-config" + '.heartbeat-incoming');
};

const getStompHeartbeatOutgoing = () => {
  return i18n.translate(WEBCHAT_PREFIX + "stomp-config" + '.heartbeat-outgoing');
};

const getStompConnectionTimeout = () => {
  return i18n.translate(WEBCHAT_PREFIX + "stomp-config" + '.connection-timeout');
};

const getChannelName = (pageId) => {
  return i18n.translate(WEBCHAT_PREFIX  + pageId + '.ichannel');
};

const getQueues = (pageId) => {
  return i18n.translate(WEBCHAT_PREFIX + pageId + '.queues');
};

const getTimeToShow = (pageId) => {
  return i18n.translate(WEBCHAT_PREFIX + pageId + '.time-before-display');
};

const getExcludeList = () => {
  // Example entry - [{"pageId":"page-ss-snap-claiming"},{"pageId":"page-ss-bank-details"},{"pageId":"page-ss-send-claiming"},{"pageId":"page-ss-claiming-review"},{"pageId":"page-ss-send-claiming-confirmation"},{"pageId":"page-ss-no-access"},{"pageId":"page-ss-where-to"}]
  return  i18n.translate(WEBCHAT_PREFIX + 'dont-show-on-pages');
};

const isLoggingOn = () => {
  return i18n.translate(WEBCHAT_PREFIX + 'console-logging');
};

/**
 * Web Chat should not be shown on a page if the bodyId from the tiles file exists in the list "web.chat.dont.show.on.pages"
 * in the web-chat-config.properties file. This will override all other configuration for Web Chat for the page.
 * An example of this are the Snap and Send pages.
 */
const isWebChatBlockedFromPage = () => {
  let pageBlocked = false;
    if (webChatConfig.hideOnPages()) {
    let dontShowOnPages = webChatConfig.hideOnPages();
    if (dontShowOnPages !== null) {
      try {
        dontShowOnPages = dontShowOnPages.trim();
        const data = JSON.parse(dontShowOnPages);
        $.each(data, (i, item) => {
          if ($('#' + item.pageId).length > 0) {
            pageBlocked = true;
          }
        });
      } catch (e) {
        console.log('Issue found trying to check if Web Chat should not be shown on page. Ignoring.');
      }
    }
  }
  return pageBlocked;
};

const configureIconBarListeners = () => {
  // Executed when user clicks on Web Chat Icon bar.
  $('#webChatIconBar').click(() => {
    // If message display is closed, then open it, otherwise close it.
    if ($('#messageDisplay').css('display') === 'none') {
      console.log('Clicked webChatIconBar so opening display');
      checkAuthenticationStatusInSession();
      setTimeout(() => {  // give cookie validation time to complete so there is no flicker on the UI when window opens.
        // If Chat is already active then open in different state
        determineOpenChatState();
        applyWindowState.applyWindowState(webChatState);
      }, 3000);
    } else {
      console.log('Clicked webChatIconBar so minimising display');
      webChatState = webChatConfig.STATE_OPEN_MINIMISED();
      applyWindowState.applyWindowState(webChatState);
    }
  });

  // If User clicks on X then End confirmation text with buttons should be shown
  $('#iconBarX').click((e) => {
    console.log('Clicked X in Chat Bar');
    if (webChatConfig.isFeedBackActive()) {
      webChatState = webChatConfig.STATE_OPEN_ENDED();
      applyWindowState.applyWindowState(webChatState);
      webChatConfig.setFeedBackActive(false);
    } else {
      webChatState = webChatConfig.STATE_OPEN_END_CONFIRM();
      applyWindowState.applyWindowState(webChatState);
    }
    e.stopPropagation();
    console.log('Finished Clicking X in Chat Bar');
  });

  // If User clicks on the Bubble Only Icon, the Web Chat Client should be shown
  $('#bubbleOnly').click((e) => {
    applyWindowState.hideElement('#bubbleOnly');
    applyWindowState.showElement('#webChatClient');
    checkForActiveWebChatInSession();
    checkAuthenticationStatusInSession();
    determineOpenChatState();
    applyWindowState.applyWindowState(webChatState);
  });
};

const configureEndChatListeners = () => {
  // If user clicks Yes on the End chat confirmation window then show ended Web Chat text.
  $('#endChatConfirmYesCTA').click((e) => {
    webSocketDisconnectGracefully();
    // Show correct window state.
    webChatState = webChatConfig.STATE_OPEN_FEEDBACK();
    applyWindowState.applyWindowState(webChatState);
  });

  // If user clicks "Yes, please send me a copy of the chat" on the End chat confirmation window then show request email input box.
  $('#endChatConfirmTranscriptCTA').click((e) => {
    const email = webChatConfig.userEmail();
    $('#defaultEmailAddress').text(email);
    webChatState = webChatConfig.STATE_OPEN_TRANSCRIPT_EMAIL();
    applyWindowState.applyWindowState(webChatState);
  });

  // If user clicks No on the End chat confirmation window then show original state again
  $('#endChatConfirmNoCTA').click((e) => {
    determineOpenChatState();
    applyWindowState.applyWindowState(webChatState);
    // If URL variable not empty, then clear it out in case user had clicked on link (MyVhi) to navigate away from
    // Portal and have now changed their mind. If empty then send Default Message to agent to indicate Customer doesn't want
    // to end chat after receiving Idle Timeout Warning message so this will reset the idle timeout counter in Live Chat Server.
    if (urlNavigatingToo !== null && urlNavigatingToo.length > 0) {
      urlNavigatingToo = null;
    } else {
      // The text in the following event must match the check in eventProcessor.js Message Received Response Event.
      stompClient.publish({
        destination: '/app/secured/room',
        body: JSON.stringify({content: 'Customer does not wish to end chat'})
      });
    }
  });

  // If user clicks Close button after ending chat without requesting a transcript
  $('#closeChatCTA').click((e) => {
    close_button();
  });

  // If user clicks close button after the text to say they have been sent a transcript of the web chat.
  $('#closeChatTranscriptSentCTA').click((e) => {
    webChatState = webChatConfig.STATE_OPEN_FEEDBACK();
    applyWindowState.applyWindowState(webChatState);
  });
};

const configureFeedBackListeners = () => {
  let webChatSurveyAnswer;
  // If user clicks on YES or NO button for answering question (Have we fully answered your questions?)
  $('#webChatFeedBackQuestionContent')
    .find('.submitBtn')
    .click( function(e) {
      e.preventDefault();
      const attr = $(this).attr('vwc-res');
      if (attr === 'yes') {
        webChatSurveyAnswer = 'Y';
      } else {
        webChatSurveyAnswer = 'N';
      }
      applyWindowState.hideElement('#webChatFeedBackQuestionContent');
      applyWindowState.showElement('#webchatFeedBackContent');
    });

  // If user selects a motion
  let feedBackSelected = false;
  $('#webchatFeedBackContent')
    .find('.webChatFeedBackImg')
    .click( function() {
      if (!feedBackSelected) {
        feedBackSelected = true;
        webChatConfig.setFeedBackActive(false);
        $(this).addClass('selected');
        
		const webChatSurveyRating = $(this).attr('vwc-res');
        const webChatSurveyData = {
          chatSurveyId: webChatConfig.chatSurveyId(),
          answer: webChatSurveyAnswer,
          rating: webChatSurveyRating,
        };

        webChatCommonApiUtils.storeWebChatSurvey(webChatSurveyData).then(() => {
        $('#webchatFeedBackContent')
          .find('.webChatFeedBackImg.selected')
		      .removeClass('selected');
          
		    feedBackSelected = false;

        // Show correct window state.
        webChatState = webChatConfig.STATE_OPEN_ENDED();
        applyWindowState.hideElement('#webchatFeedBackContent');
        applyWindowState.applyWindowState(webChatState);
        // Forward user to link if they have selected a link that is navigating away from Portal (MyVhi)
		parent.postMessage({operation: 'chatStatus', status: ''}, '*');
        navigateToUrl();
      });
	  
    }
  });

  //Click skip button on feedback panel
  $('#webChatFeedBackSkip').click( () => {
    webChatConfig.setFeedBackActive(false);
    webChatState = webChatConfig.STATE_OPEN_ENDED();
    // Show correct window state.
    applyWindowState.hideElement('#webChatFeedBackQuestionContent');
    applyWindowState.applyWindowState(webChatState);
    // Forward user to link if they have selected a link that is navigating away from Portal (MyVhi)
	parent.postMessage({operation: 'chatStatus', status: ''}, '*');
    navigateToUrl();
  });
};

const configureSendMessageBoxListener =  () => {
  // If User enters a character in the send message box, then enable "Send" button
  $('#message').on('keyup', function(e) {
    const messageValue = getUserSendMessageValue();
    if (e.which === 13 && messageValue.length > 0) {
      // if enter key clicked send message
      submitMessageForm();
    } else {
      // Dynamically increase the size of the send message text area until it's no greater than 45 in height.
      if ($(this).outerHeight() < 45) {
        while (
          $(this).outerHeight() <
          this.scrollHeight +
            parseFloat($(this).css('borderTopWidth')) +
            parseFloat($(this).css('borderBottomWidth'))
        ) {
          $(this).height($(this).height() + 1);
          $('#input_button').css({ height: '45' });
          $('#enterMessageBar').css({ height: '70' });
        }
      }
      // Enable/Disable Send Message button if any text is entered in TextArea.
      if (messageValue !== "") {
        $("#sendMessageCTA").prop("disabled", false);
      }
      else {
        $("#sendMessageCTA").prop("disabled", "disabled");
      }
    }
  });
};

const getUserSendMessageValue = () => {
  let messageValue = $('#message').val();
  // Remove any line break/carriage return from text
  messageValue = messageValue.replace(/[\n\r]/g, '');
  return messageValue;
};

/**
 * Executed when form is submitted by User to send message.
 */
const submitMessageForm = () => {
  console.log('You just submitted the form.');
  const message = getUserSendMessageValue();
  // Clear out the Message input box
  applyWindowState.resetFields();
  $('#sendMessageCTA').prop('disabled', 'disabled');
  resetTypingCounter();
  // Send message to Live Chat Server.
  stompClient.publish({
    destination: '/app/secured/room',
    body: JSON.stringify({'content': message})
  });

  // Resize Send Message Bar in case Text Area had been increased in size when user entered their message.
  $('#input_button').animate({ height: '48px' });
  $('#enterMessageBar').animate({ height: '48px' });
  $('#message').animate({ height: '30px' });
  return false;
};

const resetTypingCounter = () => {
  typingCounter = 0;
};

const handleMessageFromParent = (e) => {
  console.log("Received a message from " + e.origin + ".");
  const dataMessage = e.data;

  if (dataMessage.operation === 'myVhiLinksClicked') {
	  myVhiLinksClicked(dataMessage);
  } else if (dataMessage.operation === 'logoutLinksClicked') {
	  logoutLinksClicked(dataMessage);
  }
};

/**
 * Configure listeners for when User clicks on a link that will navigate user away from Portal
 * application and to another VHI application.
 */
 const myVhiLinksClicked = (dataMessage) => {
  console.log('User Clicked My Vhi Link'); 
  // Save the URL that the user wishes to navigate too.
  urlNavigatingToo = dataMessage.href;

  // Only show confirmation text that chat will end if there is an active web chat and the session is not authenticated.
  if (webChatConfig.chatActive() && !webChatConfig.isAuthenticated()) {
    // Collapse Menu in case this link was clicked on Mobile device and text will be hidden.
    navMenuCollapse();
    applyWindowState.applyWindowState(
      webChatConfig.STATE_LEAVING_PORTAL(),
      webChatConfig.EXT_LINKS().MYVHI
    );
  } else {
    navigateToUrl();
  }
};

const logoutLinksClicked = (dataMessage) => {
  console.log('User Clicked MyVhi Logout Link');
  // Only show confirmation text that chat will end if there is an active web chat.
  if (webChatConfig.chatActive()) {
    // Commenting out as not needed on MyVhi - Collapse Menu in case this link was clicked on Mobile device and text will be hidden.
    // Save the URL that the user wishes to navigate too.
    urlNavigatingToo = dataMessage.href;
    applyWindowState.applyWindowState(
    webChatConfig.STATE_LEAVING_PORTAL(),
    webChatConfig.EXT_LINKS().MYVHILOGOUT
    );
  }
};

const configure2FAListener = () => {
  $('#webChatPinCancel').click( () => {
    webChatState = webChatConfig.STATE_CLOSE_PIN_REQUEST();
    applyWindowState.applyWindowState(webChatState);
    applyWindowState.writeTextMessageInDisplay('PIN not verified.');
  });

  const webchatPinSubmit = () => {
    applyWindowState.hideElement('#pinNotVerified');
    const data = $('#pinInput').val();
    stompClient.publish({
      destination: '/app/secured/room',
      body: JSON.stringify({content: data, type: 'SYSTEM_PIN'})
    });
  };

  const webChatPinValidation = {
    pinInput: {
      webChatPinInput: {
        errorKey: 'web.chat.pin.Invalid',
      },
    },
  };

  $('#webChatPinForm').validate({
    rules: webChatPinValidation,
    errorPlacement: (error, element) => {
      error.insertAfter(element);
    },
    submitHandler: webchatPinSubmit,
  });
};

const configureListeners = () => {
  configureIconBarListeners();
  configureEndChatListeners();
  configureFeedBackListeners();
  configureSendMessageBoxListener();
  configure2FAListener();
};

/**
 * Build up Queue message to show to user.
 */
const setQueueStatusMessage = (message) => {
  // Add user name to queue text.
  $('#queueUserName').text(webChatConfig.userName());
  // Add response text from live chat server to queue text.
  if (message.trim() === 'CUSTOMER_NOT_FOUND') {
    console.log('Clearing queueEventTimeout : ' + webChatConfig.queueEventTimeout);
    applyWindowState.clearQueueTimeout();
    $('#queueWaitTime').text(
      'Sorry for inconvenience, please close the browser window and try again.'
    );
  } else {
    // This message will indicate that we are determining when you can be connected.
    $('#queueWaitTime').text(message);
  }
  webChatState = webChatConfig.STATE_OPEN_QUEUE();
  applyWindowState.applyWindowState(webChatState);
};

/**
 * This will make calls to live chat server to see if user is in queue and
 * show queue message on web chat client.
 */
const loadQueueMessage = () => {
  webChatConfig.setResetQueueMessageFlag(true);
  // Set flag to ensure queue message is not shown twice.
  webChatConfig.setQueueMessageAlreadyShown(true);
};

const connectToLiveChatServer = () => {
	
 webChatCommonApiUtils.getWebSocketServiceUrl().then( wsHost => { 
  const wsService = '/websocket';
  const wsContext = '/secured/room/websocket';
  const wsFirstNameParam = 'firstName=';
  const wsLaunchIdParam = 'launchIdentifier=';
  
  let wsUrl;
  if (webChatConfig.isAuthenticated()) {
    const pageId = webChatConfig.pageId();
    if (pageId === COVERCHECK_PAGEID) {
      wsUrl = wsHost + wsService + wsContext + '?' + wsLaunchIdParam + webChatConfig.channelName();
    } else {
      wsUrl = wsHost + wsService + wsContext + '?' + wsLaunchIdParam + MYVHI_CHANNEL;
    }
  } else {
	  wsUrl = wsHost + wsService + wsContext + '?' + wsFirstNameParam + webChatConfig.userName() + '&' + wsLaunchIdParam + webChatConfig.channelName();
  }

  console.log('WebSocket connection URL: ', wsUrl);
  establishWebSocketConnection(wsUrl);
	
 });

};

const establishWebSocketConnection = (wsUrl) => {

  const stompConfig = {
    brokerURL: wsUrl,
    // turn debug off for production as its quite verbose
    // debug: (str) => {
    //   console.log(str);
    // },
    reconnectDelay: getStompReconnectDelay(),
    heartbeatIncoming: getStompHeartbeatIncoming(),
    heartbeatOutgoing: getStompHeartbeatOutgoing(),
    connectionTimeout: getStompConnectionTimeout()
  };
  console.log('WebSocket stomp  config: ', stompConfig);

  stompClient = new StompJs.Client(stompConfig);
  stompClient.stompVersions = new Versions(['1.2']);
  stompClient.activate();

  stompClient.onConnect = (frame) => {
    // Do something, all subscribes must be done is this callback
    // This is needed because this will be executed after a (re)connect
    const userName = frame.headers['user-name'];
    webChatConfig.setChatActive(true);
	  parent.postMessage({operation: 'chatStatus', status: 'active'}, '*');
    webChatConfig.setChatId(userName);
    const chatSurveyId = frame.headers['vhi-survey-id'];
    webChatConfig.setChatSurveyId(chatSurveyId);
    setSocketConnected(true);
    subscription = stompClient.subscribe('/queue/webchat-specific-user-' + userName, onMessageReceived);
    // TODO: may need to set chat active here.
    webChatConfig.setChatActive(true);
    webChatConfig.setUserName(getUserName());
    webChatCommonApiUtils.storeWebChat();
  };

  stompClient.onDisconnect = (frame) => {
    console.log('onDisconnect: ', frame);
  };

  stompClient.onStompError = (frame) => {
    // Will be invoked in case of error encountered at Broker
    // Bad login/passcode typically will cause an error
    // Complaint brokers will set `message` header with a brief message. Body may contain details.
    // Compliant brokers will terminate the connection after any error
    console.log('Broker reported error: ', frame.headers['message']);
    console.log('Additional details: ', frame);
    console.log('Frame command: ', frame.command);

    setSocketConnected(false);
    // Disconnect from WebSocket.
    if (stompClient !== null) {
      subscription.unsubscribe();
      stompClient.forceDisconnect();
      stompClient.deactivate();
    }
    // We still have to close the window.
    if (frame.headers['message'] === 'Connection to broker closed.') {
      applyWindowState.applyWindowState(webChatConfig.STATE_OPEN_TIMED_OUT());
    }
  };

  stompClient.onWebSocketClose = (frame) => {
    console.log('onWebSocketClose: ', frame);
  };

  stompClient.onWebSocketError = (frame) => {
    console.log('onWebSocketError: ', frame);
    console.log('Additional details: ', frame.body);
    console.log('Frame command: ', frame.command);
    setSocketConnected(false);
    // Disconnect from WebSocket.
    if (stompClient !== null) {
      subscription.unsubscribe();
      stompClient.forceDisconnect();
      stompClient.deactivate();
    }
    // We still have to close the window.
    if (frame.headers['message'] === 'Connection to broker closed.') {
      applyWindowState.applyWindowState(webChatConfig.STATE_OPEN_TIMED_OUT());
    }
  };

  stompClient.onUnhandledFrame = (frame) => {
    console.log('onUnhandledFrame: ', frame);
  };

  stompClient.onUnhandledMessage = (frame) => {
    console.log('onUnhandledMessage: ', frame);
  };
};

const setSocketConnected = (connected) => {
  $('#startChatCTA').prop('disabled', connected);
};

const onMessageReceived = (payload) => {
  if (payload.body) {
    const body = JSON.parse(payload.body);
    const type = body.type;
    console.log('Message type -> ', type);

    if (type === 'QueuedStatusGet') {
      const message = body.message;
      console.log('QueuedStatusGet Message -> ', message);
      setQueueStatusMessage(message);
    } else if (type === 'EventsGet') {
      const events = body.events;
      // only handle exit events in here.  Messages go to the events processor.
      for (const element of events) {
        let eventData = element;
        // Null should not come back in an event but putting check just in case.
        if (eventData !== null) {
          const event = JSON.parse(eventData);
          if (event.type === 'Dropped' && event.userType === 'AGENT') {
            console.log('Chat has been dropped by agent, end the chat.');
            // Disconnect from WebSocket.
            if (stompClient !== null) {
              subscription.unsubscribe();
              stompClient.heartbeatIncoming = 0;
              stompClient.heartbeatOutgoing = 0;
              stompClient.deactivate();
            }
            // We still have to close the window.
            // Clear all intervals and Show Feedback Survey if Agent dropped the chat
            applyWindowState.clearAllEventIntervals();
            applyWindowState.applyWindowState(webChatConfig.STATE_OPEN_FEEDBACK());    
          } else if (event.type === 'UserEntered' && event.userType === 'AGENT') {
            webChatConfig.setAgentName(event.userDisplayName);
          } else if (event.type === 'LoggedOut' && event.reason === 'Could not connect to agent since agent is not available.') {
            console.log(event.reason);
            applyWindowState.applyWindowState(webChatConfig.STATE_OPEN_AGENTS_OFFLINE());
          } else if (event.type === 'TIMED_OUT') {
            console.log('Timeout out', event);
            console.log(event.reason);
          } else if (body.messageCode === 421) {
            console.log('Session expired: ', body.errorDescription, event);
            applyWindowState.applyWindowState(webChatConfig.STATE_OPEN_TIMED_OUT());
          } else {
            console.log('An event that is not necessary to preprocess before calling the eventResponseProcessor.');
            console.log('Event -> ', event);
          }
        }
      }
      eventResponseProcessor.success(body, 'AGENT');
    } else if (type === 'SendMessage') {
      if (body.events) {
        eventResponseProcessor.success(body, 'USER');
      } else if (body.messageCode === 421) {
        console.log('Session expired: ', body.errorDescription, event);
        applyWindowState.applyWindowState(webChatConfig.STATE_OPEN_TIMED_OUT());
      } else {
        console.log('Error: ', body.errorDescription);
      }
    }
  } else {
    console.log('Got an empty message.');
  }
};

const getUserName = () => {
  let userName;
  if (webChatConfig.chatActive()) {
    userName = webChatConfig.userName();
  } else {
    // remove trailing space(s) from name
    $('#webChatFirstName').val(document.getElementById('webChatFirstName').value.trim());
    userName = $('#webChatFirstName').val();
    if (webChatConfig.isAuthenticated()) {
      userName = webChatConfig.userName();
    }
  }
  return userName;
};

/**
 * Function that is called when User clicks Start Chat.
 * @returns
 */
const startWebChat = () => {
  webChatConfig.setUserName(getUserName());
  // Check availability to ensure Web Chat is STILL available.
    webChatCommonApiUtils.getCurrentWebChatAvailability(iChannelName, webChatConfig.queues())
    .then( data => {
      console.log('Availability - check web chat is still available and we can try establish a connection -> ', data);
      if (data.isChatAvailable) {
        if (data.isChatAvailable === 'true') {
          connectToLiveChatServer();
        } else if (data.isChatAvailable === 'false') {
          applyWindowState.applyWindowState(webChatConfig.STATE_OPEN_AGENTS_OFFLINE());
        }
      }
    })
    .catch( (error) => {
      console.log(error);
    });

  console.log('Finished Starting Web Chat');
};

/**
 * Validation rules for click of Start Chat button.
 */
const startWebChatValidationRules = {
  webChatFirstName: {
    webChatFirstName: true,
    minlength: 2
  }
};

/**
 * This function will be called to validate name when user enters a name and clicks start chat.
 */
const applyStartWebChatValidations = () => {
  return $('#webChatEnterNameForm').validate({
    onkeyup: function(element) {
      // remove space(s) at start of name
      $(element).val($(element).val().trimStart());
      // Name must have at least two characters
      if($(element).val().length > 1) {
        $('#webChatFirstName-error').hide();
      }
    },
    onclick: false,
    onfocusout: false,
    rules: startWebChatValidationRules,
    errorPlacement: (error, element) => {
      // Ensure Start Chat button is enabled.
      $('#startChatCTA').prop('disabled', false);
      error.insertAfter(element);
    },
    submitHandler: startWebChat,
  });
};

const init = () => {

  // IE can't retrieve session from browser so disable webchat completely for it
  if (window.document.documentMode) {
    console.log('*** IE browser detected, disabling webchat ***');
    return;
  }

  webChatIFrameInit.init();

  $.when(i18n.init())
      .done( () => {
        $('#webChatClientWrapper').localize();
        webChatInit();
      })
      .catch((err) => {
        console.log(err);
      });

  // This is to accept message from the parent representing events, such as link clicks etc
  $(document).ready(function () {
    if (window.addEventListener) {
      window.addEventListener("message", handleMessageFromParent);
    } else {
      window.attachEvent("onmessage", handleMessageFromParent);
    }
  });

  document.addEventListener("visibilitychange", handleVisibilityChangeReloadChat, false);
};

const webChatInit = () => {
	
  const pageId = applyWindowState.getPageIdFromIframeUrl();
  console.log('Loading config for pageId: ', pageId);

  let URLSearchParams = window.URLSearchParams;
  let urlSearchParams = new URLSearchParams(window.location.search);
  webChatConfig.setPageId(pageId);
  webChatConfig.setAemPage(urlSearchParams.get('aemPage'));
  webChatConfig.setChannelName(getChannelName(pageId));
  webChatConfig.setTimeToDisplay(getTimeToShow(pageId));
  webChatConfig.setHideOnPages(getExcludeList());
  webChatConfig.setQueues(getQueues(pageId));
  webChatConfig.setIsLoggingOn(isLoggingOn());

  commonValidations.pageInitialisation();
  setupConsoleLogging();
  setupConfig();
  displayWebChat();
  
};


const checkAuthenticationStatusInSession = () => {
  setUpDescriptionMarketingText();
  webChatCommonApiUtils.isAuthenticated().then(data => {
    if (data === true) {
      webChatCommonApiUtils.verifyAccessTokenCookieDetails().then(tokenData => {
        if (tokenData) { // Object is truthy
          if (tokenData.authenticated === true) {
            console.log('Authenticated session.');
            webChatConfig.setIsAuthenticated(true);
            if (tokenData.token) {
              webChatCommonApiUtils.getOktaUserInfo(tokenData.oktaUserInfoApiUrl, tokenData.token).then(userInfoData => {
                console.log('Okta userinfo API', userInfoData);
                updateIsAuthenticatedConfig(userInfoData);
                storeAuthenticatedWebChatData(tokenData);
                setUpAuthenticatedIntro();
              }).catch(error => {
                console.log('Error received verifying the okta user info : ' + error);
              });
            }
          } else {
            // Hide request transcript if user is not authenticated
            applyWindowState.hideElement('#endChatConfirmTranscriptCTA');
          }
        } else {
          webChatConfig.setIsAuthenticated(false);
          // We are going to begin a new chat now since we found an instance where we just deleted a cookie,
          // need to reset page Channel, meaning the last chat was authed
          authChatCookieDeletedStartNewUnauthChat();
        }
      });
    }
  })
  .catch((error) => {
    console.log('Error received verifying the okta access token : ' + error);
    console.log('Chat will not be authenticated.');
  });
};

const updateIsAuthenticatedConfig = (data) => {
  if (data.given_name !== null) {
    webChatConfig.setUserName(data.given_name);
  } else {
    // We are going to begin a new chat now since we found an instance where we just deleted a cookie,
    // need to reset page Channel, meaning the last chat was authed
    let channel = getChannelName(applyWindowState.getPageIdFromIframeUrl());
    webChatConfig.setChannelName(channel);
  }
  if (data.email !== null) {
    webChatConfig.setUserEmail(data.email);
  }
};

const storeAuthenticatedWebChatData = (respData) => {

  webChatCommonApiUtils.getCurrentWebChatInSession().then( currChatHistory => {

    let chatPresentedToUser = false;
    // We can't go from unauth to authed chat, the chat will be reset at that point
    let channelNameToUse = currChatHistory.channelNameToUse;

    if (respData.authenticated) {
      chatPresentedToUser = true;
      if (webChatConfig.pageId() !== COVERCHECK_PAGEID) {
        channelNameToUse = MYVHI_CHANNEL;
      }
      webChatConfig.setChannelName(channelNameToUse);
    }

	if (currChatHistory.webChatId !== null) {
      webChatConfig.setChatId(currChatHistory.webChatId);
    } else {
      console.log('We dont have a webchat ID');
    }

    const webChatContent = {
      messages: currChatHistory.messages,
      userName: webChatConfig.userName(),
      userEmail: webChatConfig.userEmail(),
      agentName: currChatHistory.agentName,
      webChatHistoryStored: currChatHistory.webChatHistoryStored,
      chatActive: currChatHistory.chatActive,
      nbrConnectedAgents: currChatHistory.nbrConnectedAgents,
      chatPresentedToUser: chatPresentedToUser,
      channelNameToUse: channelNameToUse,
      isAuthenticated: respData.authenticated,
      webChatId: currChatHistory.webChatId,
      webChatWindowMinimised: currChatHistory.webChatWindowMinimised,
      unreadMessagesCount: currChatHistory.unreadMessagesCount,
    };

    webChatCommonApiUtils.storePortalSession(webChatContent);

  });
};

const displayWebChat = () => {
	
  if ($('#webChatClient').length) {
    // Show web chat unless it's been specifically configured not too.
    if (!isWebChatBlockedFromPage()) {
      configureListeners();
      applyStartWebChatValidations();
      applySendMessageValidations();
      applyTranscriptEmailSetup();
      applySubmitTranscriptEmailValidations();
      registerKeyHandlers();
      // Ensure Start Chat button is enabled.
      $('#startChatCTA').prop('disabled', false);
      // Check for active chat in session
      checkForActiveWebChatInSession();
      applyWindowState.resetFields();
      resetTypingCounter();
    }
  }
};

const getIntroText = (firstName) => {

  const prefixi18n = WEBCHAT_PREFIX + 'message-display.auth-intro' + '.prefix';
  const prefixDefaultText = "Hello ";
  const prefix = geti18nText(prefixi18n, prefixDefaultText);

  const postfixi18n = WEBCHAT_PREFIX + 'message-display.auth-intro' + '.postfix';
  const postfixDefaulttext = ", what can we do for you today?";
  const postfix = geti18nText(postfixi18n, postfixDefaulttext);

  return prefix + firstName + postfix;
};

const setUpDescriptionMarketingText = () => {
  const createListItem = (text) => {
    const listItem = document.createElement('li');
    listItem.innerText = text;
    return listItem;
  };

  const createDescriptionList = (id, items) => {
    let list = document.getElementById(id);
    // remove existing li elements.
    list.innerHTML = '';
    items.forEach((item) => {
      const listItem = createListItem(item);
      list.appendChild(listItem);
    });
    return list;
  };

  const numberOfPointsString = geti18nText(WEBCHAT_PREFIX + 'message-display.description.number-of-points', "4");
  let numberOfPoints = parseInt(numberOfPointsString, 10);
  let points = [];
  for (let i = 1; i <= numberOfPoints; i++) {
    const point = geti18nText(WEBCHAT_PREFIX + 'message-display.description.point-'+ i, "");
    if (point) {
      points.push(point);
    }
  }
  createDescriptionList('description-points-anon', points);
  createDescriptionList('description-points-auth', points);
};

/**
 * This runs when the user passes authentication on /myvhi page
 */
const setUpAuthenticatedIntro = () => {
  if (webChatConfig.isAuthenticated()) {
    $('#unauth-intro').hide();
    $('#webChatFirstName').hide();
    $('.agentHi').hide();
    $('#webchatDescriptionHeadingAnon').hide();
    $('#webchatDescriptionAnon').hide();

    let $authIntro = $('#auth-intro');
    const firstName = webChatConfig.userName();
    $authIntro.html(getIntroText(firstName));
    $authIntro.show();
    $('#webchatDescriptionHeadingAuth').show();
    $('#webchatDescriptionAuth').show();
    // change purple arrow up button to 'Start Chat' text button
    $('#startChatCTAAuthText').show();
    $('#startChatCTA').addClass('myvhi-start-chat-button-text');
    // we need slightly different spacing for auth start chat elements
    $('#webChatNoteBeforeStart').addClass('message-display-note-auth-intro');
  }
};

/**
 * Call Live Chat Server to logout user.
 */
const webSocketDisconnectGracefully = () => {
  if (stompClient !== null) {
    subscription.unsubscribe();
    stompClient.heartbeatIncoming = 0;
    stompClient.heartbeatOutgoing = 0;
    setTimeout(() => {
      stompClient.deactivate();
    }, 1000);
  }
};

/**
 * @param jsonReference
 * @param defaultText
 * @returns either the i18n text or the hard-coded default text
 */
const geti18nText = (jsonReference, defaultText) => {
  const prefixi18nNamespace = 'webChat-messages:';

  let i18nText = i18n.translate(prefixi18nNamespace + jsonReference);

  // if the json ref isn't correct then i18n will return the json ref, so check for that also
  if (i18nText === undefined || i18nText === jsonReference) {
    i18nText = defaultText;
  }

  return i18nText;
};

/**
 * With an active chat, when user moves away to another browser window or tab and then returns to the original or other
 * tab that was displaying the chat, then clear the html messages and load the existing messages from the session
 */
const handleVisibilityChangeReloadChat = () => {
  if (document.visibilityState === "visible") {
    webChatCommonApiUtils.getCurrentWebChatInSession().then(data => {
      console.log('Current session data -> ', data);
      if (data.chatActive) {
        location.reload();
        applyWindowState.clearExistingConversation();
        if (data.webChatWindowMinimised) {
          webChatState = webChatConfig.STATE_OPEN_MINIMISED();
          applyWindowState.applyWindowState(webChatState);
        }
      } else {
        webChatConfig.setChatActive(false);
        checkWebChatAvailability(data.chatPresentedToUser);
      }
    });
  }
};

const authChatCookieDeletedStartNewUnauthChat = () => {
  iChannelName = getChannelName(applyWindowState.getPageIdFromIframeUrl());
  webChatConfig.setChannelName(iChannelName);
  webChatConfig.setQueues("");
};

module.exports = {
  getWebChatState: webChatState,
  getUrlNavigatingToo: urlNavigatingToo,
  init: init,
  _getStompClient : function () {
    return stompClient;
  },
  _onMessageReceived: onMessageReceived
};
